import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { produce } from "immer";
import { headApi } from "utils/headApi";
import { imgApi } from "utils/imgApi";
import { localApi, inshaApi } from "utils/imgApi";
import AddIcon from '@material-ui/icons/Add';
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Check from "@material-ui/icons/Check";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import style from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import styleSweet from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";
import styleCheck from "assets/jss/material-dashboard-pro-react/views/registerPageStyle";

import { credentials } from "utils/imgApi";

const useStyles = makeStyles(styles);
const useStyle = makeStyles(style);
const useStyleSweet = makeStyles(styleSweet);
const useStyCheck = makeStyles(styleCheck);

export default function AddBox(props) {
  const [boxDesc, setBoxDesc] = React.useState("");
  const [packingCharge, setPackingCharge] = React.useState("");
  const [box, setBox] = React.useState("");
  const [hsncode, setHsncode] = React.useState("");
  const [price, setPrice] = React.useState("");
  const [ligst, setLigst] = React.useState("");
  const [brandName, setBrandName] = React.useState("");

  const [boxDescErr, setBoxDescErr] = React.useState("");
  const [packChargeErr, setPackchargeErr] = React.useState("");
  const [boxErr, setBoxErr] = React.useState("");
  const [hsncodeErr, setHsncodeErr] = React.useState("");
  const [priceErr, setPriceErr] = React.useState("");
  const [ligstErr, setLigstErr] = React.useState("");
  const [brandNameErr, setBrandNameErr] = React.useState("");
  const [newBox, setNewBox] = React.useState(false);

  const [submitted, setSubmitted] = React.useState(false);
  const [alertType, alertTypeOps] = React.useState("");
  const [alertMsg, alertMsgOps] = React.useState("");
  const [btn, setBtn] = React.useState(false);

  const [items, setItems] = React.useState([]);
  const [active, setActive] = React.useState(false);
  const [multipleSelect, setMultipleSelect] = React.useState([]);
  const [newDefChild, setNewDefChild] = React.useState(false);
  const [multipleSelectErr, setMultipleSelectErr] = React.useState("");

  const classes = useStyles();
  const classe = useStyle();
  const classSweet = useStyleSweet();
  const classCheck = useStyCheck();

  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  async function getUsers() {
    const api =
      inshaApi + `/box/list/byAdminId/2`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    setItems(getResult && getResult);
    // console.log(getResult);
  }

  useEffect(() => {
    getUsers();
  }, []);

  const handleMultiple = event => {
    setMultipleSelect(event.target.value);
    setMultipleSelectErr("")
  };

  const handleBoxDesc = (index) => (e) => {
    let boxDesc = e.target.value;
    setMultipleSelect((curlab) =>
      produce(curlab, (v) => {
        v[index].boxDesc = boxDesc;
      })
    );
  };

  const handleBrandName = (index) => (e) => {
    let brandName = e.target.value;
    setMultipleSelect((curlab) =>
      produce(curlab, (v) => {
        v[index].brandName = brandName;
      })
    );
  };

  const handlePkgCharge = (index) => (e) => {
    let pkgCharge = e.target.value;
    setMultipleSelect((curlab) =>
      produce(curlab, (v) => {
        v[index].pkgCharge = pkgCharge;
      })
    );
  };

  const handleBox = (index) => (e) => {
    let box = e.target.value;
    setMultipleSelect((curlab) =>
      produce(curlab, (v) => {
        v[index].box = box;
      })
    );
  };

  const handleHsnCode = (index) => (e) => {
    let hsnCode = e.target.value;
    setMultipleSelect((curlab) =>
      produce(curlab, (v) => {
        v[index].hsnCode = hsnCode;
      })
    );
  };

  const handlePrice = (index) => (e) => {
    let price = e.target.value;
    setMultipleSelect((curlab) =>
      produce(curlab, (v) => {
        v[index].price = price;
      })
    );
  };

  const handleLigst = (index) => (e) => {
    let tax_percentage = e.target.value;
    setMultipleSelect((curlab) =>
      produce(curlab, (v) => {
        v[index].tax_percentage = tax_percentage;
      })
    );
  };

  const SubmitAddDefaultBox = (e) => {
    setNewDefChild(true);
    let errorCount = 0;
    if (!Array.isArray(multipleSelect) || multipleSelect.length < 2) {
      errorCount++;
      setMultipleSelectErr("Select at least two Product Box");
    }
    if (errorCount === 0) {
      // console.log(multipleSelect.map((m) => {
      //   return {
      //     boxDesc: m.boxDesc,
      //     brandName: m.brandName,
      //     pkgCharge: m.pkgCharge,
      //     box: m.box,
      //     hsnCode: m.hsnCode,
      //     price: m.price,
      //     tax_percentage: m.tax_percentage,
      //   }
      // }));

      setBtn(true);
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Basic ${credentials}`,
        },
        body: JSON.stringify(multipleSelect.map((m) => {
          return {
            boxDesc: m.boxDesc,
            brandName: m.brandName,
            pkgCharge: m.pkgCharge,
            box: m.box,
            hsnCode: m.hsnCode,
            price: m.price,
            tax_percentage: m.tax_percentage,
          }
        })),
      };
      fetch(localApi + `/box/addAll/${userObj.id}`, requestOptions)
        .then((res) => res.json())
        .then((data) => {
          // console.log(data);
          if (data.message === "Data Inserted Successfully !!!") {
            alertTypeOps("success");
            alertMsgOps("Succesfully !!!");
            setSubmitted(true);
          }
        });
    }
  }

  const SubmitAddBox = () => {
    setNewBox(true);
    let errorCount = 0;
    if (boxDesc === "" || !boxDesc) {
      errorCount++;
      setBoxDescErr("Description Name is Required");
    }
    if (brandName === "" || !brandName) {
      errorCount++;
      setBrandNameErr("Brand Name is Required");
    }

    if (packingCharge === "" || !packingCharge) {
      errorCount++;
      setPackchargeErr("Packing Labour is Required");
    }

    if (box === "" || !box) {
      errorCount++;
      setBoxErr("Box is Required");
    }

    if (hsncode === "" || !hsncode) {
      errorCount++;
      setHsncodeErr("HSN Code is Required");
    }

    if (price === "" || !price) {
      errorCount++;
      setPriceErr("Price is Required");
    }

    if (ligst === "" || !ligst) {
      errorCount++;
      setLigstErr("GST is Required");
    }

    if (errorCount === 0) {
      setBtn(true);
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Basic ${credentials}`,
        },
        body: JSON.stringify({
          boxDesc: boxDesc,
          brandName: brandName,
          pkgCharge: packingCharge,
          box: box,
          hsnCode: hsncode,
          price: price,
          tax_percentage: ligst,
        }),
      };

      fetch(localApi + `/box/add/${userObj && userObj.id}`, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          // console.log(data);
          if (data.message === "Data Inserted Successfully !!!") {
            alertTypeOps("success");
            alertMsgOps("Succesfully");
            setSubmitted(true);
          }
        });
    }
  };

  const hideAlert = () => {
    setSubmitted(false);
    window.location.reload(false);
  };

  return (
    <div>
      <GridContainer justify="center" alignItems="center">
        <GridItem xs={12} sm={active === true ? 12 : 12} md={active === true ? 12 : 6}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <AddIcon />
              </CardIcon>
              <h3 className={classes.cardIconTitle}>
                <small>Add Box</small>
                {active === true ? newDefChild === true ? (
                  <small
                    style={{
                      fontSize: "12px",
                      color: "red",
                      marginLeft: "10px",
                    }}
                  >
                    {multipleSelectErr}
                  </small>
                ) : (
                  <small style={{ fontSize: "12px", marginLeft: "10px" }}>
                    Enter Box Description
                  </small>
                ) : newBox === true ? (
                  <small
                    style={{
                      fontSize: "12px",
                      color: "red",
                      marginLeft: "10px",
                    }}
                  >
                    {boxDescErr || brandNameErr || packChargeErr || boxErr || hsncodeErr || ligstErr}
                  </small>
                ) : (
                  <small style={{ fontSize: "12px", marginLeft: "10px" }}>
                    Enter Box Description
                  </small>
                )}
              </h3>
            </CardHeader>
            <CardBody>
              <GridContainer>
                {submitted ? (
                  <SweetAlert
                    type={alertType}
                    style={{ display: "block", marginTop: "-100px" }}
                    title={alertMsg}
                    onConfirm={() => hideAlert()}
                    confirmBtnCssClass={
                      classSweet.button + " " + classSweet.success
                    }
                  >Added Box</SweetAlert>
                ) : null}
                {" "}
                {active === false ? <>
                  <GridItem xs={12} sm={6} md={6}>
                    <CustomInput
                      labelText="Box Description..."
                      id="boxDesc"
                      inputProps={{
                        placeholder: "Ex. 12 Sets in 1 Box...",
                      }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      name="boxDesc"
                      value={boxDesc}
                      onChange={(e) => {
                        setBoxDesc(e.target.value);
                        setBoxDescErr("");
                      }}
                      required={true}
                    />
                    {/* <span style={{ color: "red" }}>{boxDescErr}</span> */}
                  </GridItem>
                  <GridItem xs={12} sm={6} md={6}>
                    <CustomInput
                      labelText="Brand Name..."
                      id="brandName"
                      inputProps={{
                        placeholder: "Ex. Omega Bangles...",
                      }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      name="brandName"
                      value={brandName}
                      onChange={(e) => {
                        setBrandName(e.target.value);
                        setBrandNameErr("");
                      }}
                      required={true}
                    />
                    {/* <span style={{ color: "red" }}>{brandNameErr}</span> */}
                  </GridItem>
                  <GridItem xs={12} sm={6} md={6}>
                    <CustomInput
                      labelText="Box Packing Labour..."
                      id="packingCharge"
                      inputProps={{
                        placeholder: "Ex. 12...",
                      }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      name="packingCharge"
                      value={packingCharge}
                      onChange={(e) => {
                        setPackingCharge(e.target.value);
                        setPackchargeErr("");
                      }}
                      required={true}
                    />
                    {/* <span style={{ color: "red" }}>{packChargeErr}</span> */}
                  </GridItem>
                  <GridItem xs={12} sm={6} md={6}>
                    <CustomInput
                      labelText="Box 6/12/18..."
                      id="box"
                      inputProps={{
                        placeholder: "Ex. 12...",
                      }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      name="box"
                      value={box}
                      onChange={(e) => {
                        setBox(e.target.value);
                        setBoxErr("");
                      }}
                      required={true}
                    />
                    {/* <span style={{ color: "red" }}>{boxErr}</span> */}
                  </GridItem>
                  <GridItem xs={12} sm={4} md={4}>
                    <CustomInput
                      labelText="HSN Code..."
                      id="hsncode"
                      inputProps={{
                        placeholder: "Ex. 4819...",
                      }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      name="hsncode"
                      value={hsncode}
                      onChange={(e) => {
                        setHsncode(e.target.value);
                        setHsncodeErr("");
                      }}
                      required={true}
                    />
                    {/* <span style={{ color: "red" }}>{hsncodeErr}</span> */}
                  </GridItem>
                  <GridItem xs={12} sm={4} md={4}>
                    <CustomInput
                      labelText="Price..."
                      id="price"
                      inputProps={{
                        placeholder: "Ex. 8.50...",
                      }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      name="price"
                      value={price}
                      onChange={(e) => {
                        setPrice(e.target.value);
                        setPriceErr("");
                      }}
                      required={true}
                    />
                    {/* <span style={{ color: "red" }}>{priceErr}</span> */}
                  </GridItem>
                  <GridItem xs={12} sm={4} md={4}>
                    <CustomInput
                      labelText="Tax Rate..."
                      id="ligst"
                      inputProps={{
                        placeholder: "Ex. 18...",
                      }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      name="ligst"
                      value={ligst}
                      onChange={(e) => {
                        setLigst(e.target.value);
                        setLigstErr("");
                      }}
                      required={true}
                    />
                    {/* <span style={{ color: "red" }}>{ligstErr}</span> */}
                  </GridItem>
                </> : ""}
                <GridItem xs={12} sm={12} md={12}>
                  <FormControlLabel
                    classes={{
                      root: classCheck.checkboxLabelControl,
                      label: classCheck.checkboxLabel,
                    }}
                    control={
                      <Checkbox
                        id="active"
                        value={active}
                        checked={
                          active & (active === true) ? active : active
                        }
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setActive(checked);
                          if (!checked) {
                            // If checkbox is unchecked, clear multipleSelect
                            setMultipleSelect([]);
                            setMultipleSelectErr(""); // Also clear any errors if needed
                          }
                        }}
                        tabIndex={-1}
                        checkedIcon={
                          <Check className={classCheck.checkedIcon} />
                        }
                        icon={
                          <Check className={classCheck.uncheckedIcon} />
                        }
                        classes={{
                          checked: classCheck.checked,
                          root: classCheck.checkRoot,
                        }}
                      />
                    }
                    label={
                      <span style={{ color: "#9c27b0" }}>
                        Would you like to save the default Box?
                      </span>
                    }
                  />
                </GridItem>

                {active === true ?
                  <GridItem xs={12} sm={12} md={12}>
                    <FormControl
                      fullWidth
                      className={classe.selectFormControl}
                    >
                      <InputLabel
                        htmlFor="multiple-select"
                        className={classe.selectLabel}
                      >
                        Select Box Description...
                      </InputLabel>
                      <Select
                        multiple
                        value={multipleSelect}
                        onChange={handleMultiple}
                        MenuProps={{ className: classe.selectMenu }}
                        classes={{ select: classe.select }}
                        inputProps={{
                          name: "multipleSelect",
                          id: "multiple-select"
                        }}
                      >
                        <MenuItem
                          disabled
                          classes={{
                            root: classe.selectMenuItem
                          }}
                        >
                          Select Box Description...
                        </MenuItem>
                        {items &&
                          items.map((item2) => (
                            <MenuItem
                              key={item2.id}
                              value={item2}
                              classes={{
                                root: classe.selectMenuItem,
                                selected: classe.selectMenuItemSelectedMultiple,
                              }}
                            >
                              {item2.boxDesc + " - " + item2.brandName}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </GridItem>
                  : ""}
              </GridContainer>
              <GridContainer>
                {multipleSelect &&
                  multipleSelect.map((Ele, index) => (
                    <GridItem xs={12} sm={6} md={4} key={Ele.id} value={Ele.id}>
                      <Card>
                        <CardBody>
                          <GridContainer>
                            <GridItem xs={12} sm={6} md={6}>
                              <CustomInput
                                labelText={"Box Description..." + Ele.id}
                                id="boxDesc"
                                inputProps={{
                                  placeholder: "Ex. 12 Sets in 1 Box...",
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                name="boxDesc"
                                value={Ele.boxDesc}
                                onChange={handleBoxDesc(index)}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={6} md={6}>
                              <CustomInput
                                labelText={"Brand Name..."}
                                id="brandName"
                                inputProps={{
                                  placeholder: "Ex. Omega Bangles...",
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                name="brandName"
                                value={Ele.brandName}
                                onChange={handleBrandName(index)}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={6} md={6}>
                              <CustomInput
                                labelText={"Box Packing Labour..."}
                                id="packingCharge"
                                inputProps={{
                                  placeholder: "Ex. 12...",
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                name="packingCharge"
                                value={Ele.pkgCharge}
                                onChange={handlePkgCharge(index)}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={6} md={6}>
                              <CustomInput
                                labelText={"Box 6/12/18..."}
                                id="box"
                                inputProps={{
                                  placeholder: "Ex. 12...",
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                name="box"
                                value={Ele.box}
                                onChange={handleBox(index)}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={4} md={4}>
                              <CustomInput
                                labelText={"HSN Code..."}
                                id="hsncode"
                                inputProps={{
                                  placeholder: "Ex. 4819...",
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                name="hsncode"
                                value={Ele.hsnCode}
                                onChange={handleHsnCode(index)}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={4} md={4}>
                              <CustomInput
                                labelText={"Price..."}
                                id="price"
                                inputProps={{
                                  placeholder: "Ex. 10.50...",
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                name="price"
                                value={Ele.price}
                                onChange={handlePrice(index)}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={4} md={4}>
                              <CustomInput
                                labelText={"Tax Rate..."}
                                id="ligst"
                                inputProps={{
                                  placeholder: "Ex. 18...",
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                name="ligst"
                                value={Ele.tax_percentage}
                                onChange={handleLigst(index)}
                              />
                            </GridItem>
                          </GridContainer>
                        </CardBody>
                      </Card>
                    </GridItem>
                  ))}
              </GridContainer>
              {btn === true ? (
                <Button className={classes.updateProfileButton}>Save</Button>
              ) : (
                active === true ? (
                  <Button
                    color="rose"
                    onClick={SubmitAddDefaultBox}
                    className={classes.updateProfileButton}
                  >
                    Save Default
                  </Button>
                ) :
                  <Button
                    color="rose"
                    onClick={SubmitAddBox}
                    className={classes.updateProfileButton}
                  >
                    Save
                  </Button>
              )}
              {/* <Button
                color="rose"
                onClick={SubmitAddBox}
                className={classes.updateProfileButton}
              >
                Save
              </Button> */}
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
AddBox.propTypes = {
  avatar: PropTypes.bool,
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object,
};
